import { Component } from "@angular/core";
import { OrdersComponent } from "../../orders.component";

@Component({
  selector: "jni-all-sales-listing",
  templateUrl: "./all-sales-listing.component.html",
  styleUrls: ["./all-sales-listing.component.css"],
  imports: [OrdersComponent],
})
export class AllSalesListingComponent {}
